import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS) => ({
    labelContainer: {
        display: 'flex',
        justify_content: 'center',
    },
    scaleContainer: {
        display: 'none',
    },
    buttonsTracksContainer: {
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_150,
        order: '2',
    },
    tracksThumbsContainer: {
        position: 'relative',
        width: '100%',
        height: FOUNDATIONS.size_375,
    },
    tracksThumbsInnerContainer: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    },
    helperTextContainer: {
        display: 'flex',
        justify_content: 'space-between',
    },
    thumbExceedsTrack: false,
});
export const labelCommonStyles = (FOUNDATIONS) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_250,
    font_weight: FONT_WEIGHT.font_bold,
    text_align: TEXT_ALIGN.center,
    color: FOUNDATIONS.color_neutral_font_50,
});
export const helperTextCommonStyles = (FOUNDATIONS) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_250,
    font_weight: FONT_WEIGHT.font_bold,
    text_align: TEXT_ALIGN.center,
    color: FOUNDATIONS.color_neutral_font_100,
});
export const containerCommonStyles = (FOUNDATIONS) => ({
    display: 'flex',
    flex_direction: 'column',
    gap: FOUNDATIONS.spacing_100,
});
export const thumbCommonStyles = (FOUNDATIONS) => ({
    position: 'absolute',
    box_sizing: 'border-box',
    pointer_events: 'inherit',
    overflow: 'visible',
    display: 'flex',
    justify_content: 'center',
    align_items: 'center',
    border_radius: FOUNDATIONS.radius_275,
    height: FOUNDATIONS.size_375,
    width: FOUNDATIONS.size_375,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    border_width: FOUNDATIONS.border_50,
    border_style: 'solid',
    border_color: FOUNDATIONS.color_comp_forms_slider_handle_border,
    background_color: FOUNDATIONS.color_comp_forms_slider_handle_bg,
});
export const rightThumbCommonStyles = (FOUNDATIONS) => ({
    ...thumbCommonStyles(FOUNDATIONS),
    transform: 'translate(50%, -50%)',
});
export const thumbIconCommonStyles = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_125,
    height: FOUNDATIONS.size_125,
    color: FOUNDATIONS.color_comp_forms_slider_handle_icon,
});
export const thumbRightIconCommonStyles = (FOUNDATIONS) => ({
    ...thumbIconCommonStyles(FOUNDATIONS),
});
export const activeTrackCommonStyles = (FOUNDATIONS) => ({
    position: 'absolute',
    height: FOUNDATIONS.size_100,
    top: '50%',
    transform: 'translateY(-50%)',
    border_radius: FOUNDATIONS.radius_100,
    background_color: FOUNDATIONS.color_comp_forms_slider_bar_bg,
});
export const inactiveTrackCommonStyles = (FOUNDATIONS) => ({
    position: 'absolute',
    height: FOUNDATIONS.size_100,
    top: '50%',
    transform: 'translateY(-50%)',
    border_radius: FOUNDATIONS.radius_100,
    background_color: FOUNDATIONS.color_neutral_bg_onsurface_55,
});
//# sourceMappingURL=commonStyles.js.map